import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeProductWrite } from './serialize';

/**
 * 建立產品。
 * `POST /crm/product` → 201；預設 ACTIVE；**不送** status。
 * materials 至少一筆；只送 `mtrId`（不送 materialId alias）。
 *
 * @param {object} payload — camelCase
 */
export async function createProduct(payload) {
  const { data: raw } = await request.post(
    '/crm/product',
    serializeProductWrite(payload),
  );
  return parseVer4DetailResponse(raw);
}
